import type { SessionUser } from '@/api/profile/types';

/**
 * Whether the session's company has a platform feature granted.
 *
 * The same predicate `useFeatures` applies, in a form router guards can call —
 * `beforeLoad` runs outside React, so it cannot use the hook. `enabledFeatures`
 * comes from `GET /api/users/me`, which already filters to active grants on both
 * `platform_features` and `companies_platform_features`, so an absent entry and
 * a toggle turned off are indistinguishable here — both mean "not granted".
 */
export function hasFeature(
  user: SessionUser | null | undefined,
  featureId: string,
): boolean {
  return Boolean(user?.company?.enabledFeatures?.some(f => f.id === featureId));
}
